import {useEffect} from 'react'

const resizeObserver = {current: null}
const cbs = []

const useResizeObserver = (ref, callback, effectProps = []) => {
	useEffect(() => {
		const localRef = ref.current || ref

		// create a single static resize observer
		if (!resizeObserver.current) {
			resizeObserver.current = new ResizeObserver(entries => {
				cbs.forEach((cb, i) => {
					const entry = entries.find(e => {
						return (cb.ref.current || cb.ref) === e.target
					})
					if (entry) cb.callback(entry, i)
				})
			})
		}

		// observe ref target
		resizeObserver.current.observe(localRef)
		cbs.push({ref, callback})

		return () => {
			// unobserve ref target
			if(resizeObserver.current) {
				resizeObserver.current.unobserve(localRef)
				const index = cbs.findIndex(e => e.callback === callback)
				if (index !== -1) {
					cbs.splice(index, 1)
					if (cbs.length === 0) {
						resizeObserver.current.disconnect()
						resizeObserver.current = null
					}
				}
			}
		}
	}, [ref, ...effectProps])
}

export default useResizeObserver
